import { CustomQueryOptions } from '@/common/types_and_interfaces.ts'
import { queryOptions } from '@tanstack/react-query'
import {
  CoutryList,
  GetCountryList,
  GetHelpLink,
  GetStateByContryId,
  GetTimeZoneList,
  HelpLinkResponse,
  StateList,
  TimeZoneList,
} from './requests'

const ContryListKeys = {
  details: () => ['country_list'],
} as const
const StateQueryKeys = {
  details: (countryId: number) => ['state_list', countryId],
} as const
const TimeZonesKeys = {
  details: () => ['timezone_list'],
} as const
const HelpLinkKeys = {
  details: (programId: number, type: number) => ['help_link', programId, type],
} as const;

export class CommonQueries {
  public static FetchCommonCountries(
    options: CustomQueryOptions<CoutryList> = {}
  ) {
    return queryOptions({
      queryKey: ContryListKeys.details(),
      queryFn: () => GetCountryList(),
      ...options,
    })
  }
  public static FetchStateByContry(
    countryId?: number,
    options: CustomQueryOptions<StateList> = {}
  ) {
    return queryOptions({
      queryKey: StateQueryKeys.details(countryId!),
      queryFn: () => GetStateByContryId(countryId),
      ...options,
    })
  }
  public static FetchTimeZones(options: CustomQueryOptions<TimeZoneList> = {}) {
    return queryOptions({
      queryKey: TimeZonesKeys.details(),
      queryFn: () => GetTimeZoneList(),
      ...options,
    })
  }
  public static FetchHelpLink(
    programId: number,
    type: number,
    options: CustomQueryOptions<HelpLinkResponse> = {}
  ) {
    return queryOptions({
      queryKey: HelpLinkKeys.details(programId, type),
      queryFn: () => GetHelpLink(programId, type),
      ...options,
    })
  }
}
